import { createContext, type ReactNode } from "react";

export type NavigationTabContextType<
  Tabs extends readonly string[] = readonly string[],
> = {
  tabs: Tabs;
  factory: (tab: Tabs[number]) => ReactNode;
  tabName: Tabs[number];
};

export const NavigationTabContext = createContext<
  NavigationTabContextType | undefined
>(undefined);
